import { createSelector } from 'reselect'

import { selectQbrState } from './selectQbrState'

export const selectQbrNetNdp = createSelector(
  [selectQbrState],
  (state) => state.documentSettings.netNdp
)
